import { createAction } from '@reduxjs/toolkit';
import { nameSpace } from '../Modules/nameSpace';

const postEvidenceTask = createAction(`${nameSpace}/postEvidenceTask`);
const abortPatrolTask = createAction(`${nameSpace}/abortPatrolTask`);
const startVirtualPatrol = createAction(`${nameSpace}/startVirtualPatrol`);
const uploadVirtualPatrol = createAction(`${nameSpace}/uploadVirtualPatrol`);
const printList = createAction(`${nameSpace}/printList`);
const printDetails = createAction(`${nameSpace}/printDetails`);
export {
  postEvidenceTask,
  abortPatrolTask,
  startVirtualPatrol,
  uploadVirtualPatrol,
  printList,
  printDetails,
};
